
"use client" 

import { useContext } from 'react';
import { ConfigContext } from '@/app/contexts/ConfigContext';
// ==============================|| CONFIG - HOOKS  ||============================== //
const useConfig = () => useContext(ConfigContext);

export default useConfig;


/*
import React, { createContext } from 'react';
const ConfigContext = createContext();
export { ConfigContext };

// import { ConfigContext } from '@/app/contexts/ConfigContext';

const useConfig = () => useContext(ConfigContext);

export default useConfig;

*/
